/**
 * 数据集
 *
 * @see https://echarts.apache.org/handbook/zh/concepts/dataset
 * @see https://vega.github.io/vega-lite/docs/encoding.html
 * @see https://vega.github.io/vega/docs/transforms/bin/
 */
import { transform, type TransformItem } from './data-transform';

export type TabularDataset = { [key: string]: string | number }[];

type EncodeParams = {
  field: string;
  transforms?: TransformItem[];
};

type Encoding = {
  [key: string]: (params: EncodeParams) => (string | number)[];
};

type Params = {
  [K in keyof Encoding]: Parameters<Encoding[K]>[0];
};

type Result = {
  [K in keyof Encoding]: ReturnType<Encoding[K]>;
};

export function encoding(data: TabularDataset, params: Params): Result {
  const encodeKeys = Object.keys(params) as (keyof typeof params)[];

  return encodeKeys.reduce((result, encodeKey) => {
    const { field, transforms = [] } = params[encodeKey]!;
    let encodeResult;

    if (typeof field !== 'undefined') {
      encodeResult = data.map(item => item[field]);
      encodeResult = transform(encodeResult, transforms)!;
    }

    return { ...result, [encodeKey]: encodeResult };
  }, {} as Result);
}
